<template>
  <el-card class="iot-person public-page-style iot-search-header">
    <div slot="header">
      <el-form :inline="true" :model="getForm">
        <el-form-item>
          <el-input
            size="small"
            clearable
            v-model="getForm.protocolName"
            placeholder="请输入要查询的通讯协议名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" plain @click="checkTable()"
            >查询</el-button
          >
        </el-form-item>
        <el-button
          type="primary"
          size="mini"
          class="iot-communicationProtocol-create"
          @click="addcommunicationProtocol()"
          >新增通讯协议</el-button
        >
      </el-form>
    </div>
    <div style="height:678px;overflow-y: auto;">
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{ background: theme.TABLE_HEADER_COLOR }"
    >
      <el-table-column prop="protocolId" label="ID"></el-table-column>
      <el-table-column prop="protocolName" label="协议名称"></el-table-column>
      <el-table-column prop="remark" label="协议名称"></el-table-column>
      <el-table-column prop="createTime" label="开始时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="edit(scope.row.protocolId)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="del(scope.row.protocolId)"
            >删除</el-button
          >
        </template>
      </el-table-column>
 
    </el-table>
    </div>
      <div class="page">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
        :total="total"
        :page-size="getForm.size"
        layout="total, sizes, prev, pager, next, jumper"
        @prev-click="
          () => {
            $set(getForm, 'current', getForm.current - 1);
            getList();
          }
        "
        @next-click="
          () => {
            $set(getForm, 'current', getForm.current + 1);
            getList();
          }
        "
      >
      </el-pagination>
    </div>
    <el-dialog
    top="3%"
      title="填写表单"
      :show-close="false"
      :visible.sync="communicationProtocolDialogVisinbile"
      :before-close="handleClose"
      :destroy-on-close="true"
      :close-on-press-escape="true"
      :close-on-click-modal="false"
    >
      <el-form
        :model="communicationProtocolForm"
        ref="subRef"
        :rules="rules"
        label-position="top"
      >
        <el-form-item label="通讯协议" label-width="120" prop="protocolName">
          <el-input
            v-model="communicationProtocolForm.protocolName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" label-width="120" prop="remark">
          <el-input
            v-model="communicationProtocolForm.remark"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
         <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="communicationProtocolDialogVisinbile = false"
          >取 消</el-button
        >
       
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { TABLE_HEADER_COLOR } from "../util/theme";
let that;
export default {
  name: "CommunicationProtocol",
  props: {
    msg: String,
  },
  data() {
    return {
      theme: { TABLE_HEADER_COLOR },
      tableData: [],
      getForm: {
        current: 1,
        size: 10,
        protocolName: "",
      },
      total: 0,
      communicationProtocolDialogVisinbile: false,
      communicationProtocolForm: {
        protocolId: "",
        protocolName: "",
        remark: "",
      },
      isCreate: true,
      rules: {
        protocolName: [
          { required: true, message: "请输入通讯协议名称", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    handleSizeChange(val) {
        that.getForm.size=val;
        that.getList();
      },
      handleCurrentChange(val) {
        that.getForm.current=val;
        that.getList();
      },
    getList: function () {
      that.$api.communicationProtocol
        .getListData(that.getForm)
        .then((response) => {
          that.tableData = response.data.records;
          that.total = response.data.total;
        });
    },
    handleClose: function () {
      that.communicationProtocolDialogVisinbile = false;
    },
    addcommunicationProtocol: function () {
      that.communicationProtocolDialogVisinbile = true;
      that.isCreate = true;
    },
    edit: function (id) {
      that.$api.communicationProtocol
        .communicationProtocolDetail(id)
        .then((response) => {
          that.communicationProtocolDialogVisinbile = true;
          that.isCreate = false;
          that.communicationProtocolForm = response.data;
        });
    },
    del: function (id) {
      that
        .$confirm("确认删除", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.$api.communicationProtocol
            .delcommunicationProtocol(id)
            .then(() => {
              that.getList();
              that.$message({
                message: "删除成功",
                type: "success",
              });
            });
        })
        .catch(() => {});
    },
    checkTable: function () {
      that.getList();
    },
    submitForm: function () {
      that.$refs["subRef"].validate((valid) => {
        if (valid) {
          let _api = that.isCreate
            ? that.$api.communicationProtocol.addcommunicationProtocol(
                that.communicationProtocolForm
              )
            : that.$api.communicationProtocol.editcommunicationProtocol(
                that.communicationProtocolForm
              );
          _api.then((response) => {
            if (response.code == 200) {
              that.communicationProtocolDialogVisinbile = false;
              that.isCreate = true;
              that.getList();
              that.$message({
                type: "success",
                message: "请求成功",
              });
              that.$refs.subRef.resetFields();
            }
          });
        }
      });
    },
  },
  beforeMount: function () {
    that = this;
  },
  mounted: function () {
    that.getList();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iot-communicationProtocol-create {
  float: right;
  margin-top: 10px;
}
.iot-communicationProtocol-permission {
  height: 387px;
}
.iot-search-header >>> .el-card__header {
  padding: 0 18px;
}
.iot-person >>> .el-select {
  width: 100%;
}
.page{
  display: flex;
  justify-content: flex-end;
}
</style>
